import { render } from "./activityDataResultModal.vue?vue&type=template&id=9f312ea0&ts=true"
import script from "./activityDataResultModal.vue?vue&type=script&lang=ts"
export * from "./activityDataResultModal.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__